import { render, staticRenderFns } from "./SetPwd.vue?vue&type=template&id=5e30cbe6&scoped=true&"
import script from "./SetPwd.vue?vue&type=script&lang=js&"
export * from "./SetPwd.vue?vue&type=script&lang=js&"
import style0 from "./SetPwd.vue?vue&type=style&index=0&id=5e30cbe6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e30cbe6",
  null
  
)

export default component.exports